<template>
  <div class="card">
    <div class="is-paddingless">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center pdt-20px pdh-5">
        <h1 class="title is-size-3">
          {{ $t('catalogue.popUpEditionPlanningReseauxTemposLc.title') }}
        </h1>
      </div>
      <div class="card-content">
        <error-msg-component
          :messages="messagesError"
          :error="error"
          title="general.problemOccurred"
          @close="error = $event"/>
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field
              :label="$t('catalogue.popUpEditionPlanningReseauxTemposLc.dateReference')"
              class="obligatoire">
              <b-datepicker
                v-model="dateReference"
                icon="calendar-today"
                editable
                show-week-number
                nearby-selectable-month-days>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-6">
            <qd-radio
              v-model="format"
              :native-value="constantes.TYPE_PDF">
              {{ $t('general.popUpEdition.type.pdf') }}
            </qd-radio>
            <qd-radio
              v-model="format"
              class="mgl-10px"
              :native-value="constantes.TYPE_DOCX">
              {{ $t('general.popUpEdition.type.docx') }}
            </qd-radio>
          </div>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <button
                class="button"
                @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </button>
            </div>
            <div class="is-pulled-left boutonAction">
              <button
                class="button is-addOrEdit"
                @click="editionPlanning()">
                {{ $t('general.button.valider') }}
              </button>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import edition from '@/api/edition';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import messageErreur from '@/services/general/messageErreur';
import validationEdition from '@/services/general/validation/validationRetourEdition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

export default {
  name: 'PopUpEditionPlanningReseauxTemposLC',
  props: {
    produits: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      messagesError: [],
      dateReference: null,
      format: TYPE_PDF,
      constantes: {
        TYPE_PDF,
        TYPE_DOCX,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    produitsReseauxIds() {
      return this.produits
        .filter(p => [produitConf.CATEGORIE_REGROUPEMENT, produitConf.CATEGORIE_REGROUPEMENT_LC]
          .includes(p.supportCommercial.categorieVente))
        .map(p => p.id);
    },
  },
  methods: {
    validation() {
      this.messagesError = [];
      this.error = false;
      if (!this.dateReference) {
        this.messagesError.push({
          message: 'catalogue.popUpEditionPlanningReseauxTemposLc.dateReferenceMsgRequired',
        });
      }
      if (this.produitsReseauxIds.length === 0) {
        this.messagesError.push({
          message: 'catalogue.popUpEditionPlanningReseauxTemposLc.produitsMsgRequired',
        });
      }
      if (this.messagesError.length > 0) {
        this.error = true;
      }
      return this.error;
    },
    async editionPlanning() {
      const error = this.validation();
      if (error) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: this.produitsReseauxIds,
          extension: this.format,
          typeDonnee: produitConf.TYPE_EDITION_PLANNING_RESEAU_TEMPO_LC_REGIE_MEDIA,
          typeEdition: '',
          parametresAdditionnels: {
            anneeReference: moment(this.dateReference).year(),
          },
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition(response, this.messagesErreur);
          this.isError = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw (e);
      }
    },
  },
  mounted() {
    this.dateReference = (moment().startOf('year')).toDate();
  },
};

</script>
